import { useCreateUserMutation } from '@axilon-apps/domains-identity/state'
import { useFeedbackMessage, useFlashMessages } from '@axilon-apps/libs-ui-components'
import type {
  EntitiesCreateUserRequest,
  EntitiesUserResponse,
  FieldErrors
} from '@axilon-apps/domains-identity/types'
import type { Maybe } from '@axilon-apps/libs-shared-types'

import { UsersFlashMessageGroup } from '../../../constants/users-flash-message-groups'

type LegacyUserCreationResponse = EntitiesUserResponse & { password: string }

interface ErrorResponse {
  message?: Maybe<string>
  fields?: Record<string, string[]>
}

interface Props {
  onSuccess?: (result: LegacyUserCreationResponse) => void
}

const useCreateUser = ({ onSuccess }: Props) => {
  const { toast } = useFeedbackMessage()
  const flash = useFlashMessages(UsersFlashMessageGroup.AddUser)

  const [createUserMutation, result] = useCreateUserMutation()

  const fieldErrors = (result.error as ErrorResponse)
    ?.fields as FieldErrors<EntitiesCreateUserRequest>

  const submit = async ({ name, username, email }: EntitiesCreateUserRequest) => {
    flash.clear()
    const trimmedEmail = email?.trim()
    const { data, error } = await createUserMutation({
      name,
      username,
      ...(trimmedEmail ? { email: trimmedEmail } : {})
    })
    if (data && data.password) {
      const flattened: LegacyUserCreationResponse = { ...data.user, password: data.password }
      onSuccess?.(flattened)

      toast.success({
        message: `User: ${flattened.username} was added successfuly`
      })
    }
    if (error) {
      flash.error({ message: error.message })
    }
  }
  const reset = () => {
    result.reset()
    flash.clear()
  }

  return {
    submit,
    fieldErrors,
    reset,
    result
  }
}

export default useCreateUser
